/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/sections/homepage/featured-collections-tabs.js":
/*!********************************************************************!*\
  !*** ./zrc/scripts/sections/homepage/featured-collections-tabs.js ***!
  \********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! swiper */ \"./node_modules/swiper/swiper.esm.js\");\n/* harmony import */ var _shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @shopify/theme-sections */ \"./node_modules/@shopify/theme-sections/theme-sections.js\");\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! hequalizer */ \"./node_modules/hequalizer/hequalizer.min.js\");\n/* harmony import */ var hequalizer__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(hequalizer__WEBPACK_IMPORTED_MODULE_2__);\n\n\n\nconst sectionId = \"section-fct\";\nclass FeaturedCollectionsTabs {\n  constructor($section) {\n    this.$section = $section;\n    this.hequalizerImages = [];\n    this.configTabs();\n  }\n  configSwipper(contentContainer) {\n    const $carouselContainer = contentContainer.querySelector(\".fct-items\");\n    if ($carouselContainer.classList.contains(\"swiper-initialized\")) {\n      const $images = contentContainer.querySelectorAll(\".product-card-image-wrapper\");\n      $images.forEach($image => {\n        $image.style.setProperty(\"--height\", \"unset\");\n      });\n      this.hequalizerImages[contentContainer.dataset.index].update();\n      $carouselContainer.swiper.update();\n      window.dispatchEvent(new window.Event(\"resize\"));\n    } else {\n      this.configHeights(contentContainer);\n      this.swiper = new swiper__WEBPACK_IMPORTED_MODULE_0__.default($carouselContainer, {\n        init: false,\n        loop: false,\n        speed: 200,\n        slidesPerView: \"auto\",\n        variableWidth: true,\n        centerInsufficientSlides: true,\n        simulateTouch: true,\n        allowTouchMove: true,\n        threshold: 0,\n        longSwipesRatio: 0,\n        resistanceRatio: 0,\n        breakpoints: {\n          1: {\n            spaceBetween: 6.9\n          },\n          1440: {\n            spaceBetween: 8.2\n          }\n        }\n      });\n      this.swiper.init();\n    }\n  }\n  configHeights(contentContainer) {\n    const $images = contentContainer.querySelectorAll(\".product-card-image-wrapper\");\n    const $reviews = contentContainer.querySelectorAll(\".product-card-reviews-wrapper\");\n    const $titles = contentContainer.querySelectorAll(\".product-card-title-wrapper\");\n    const $prices = contentContainer.querySelectorAll(\".product-card-price-wrapper\");\n    const $notes = contentContainer.querySelectorAll(\".product-card-notes-wrapper\");\n    const $levels = contentContainer.querySelectorAll(\".product-card-level-wrapper\");\n    const hequalizerImages = new (hequalizer__WEBPACK_IMPORTED_MODULE_2___default())($images, {});\n    new (hequalizer__WEBPACK_IMPORTED_MODULE_2___default())($reviews, {});\n    new (hequalizer__WEBPACK_IMPORTED_MODULE_2___default())($titles, {});\n    new (hequalizer__WEBPACK_IMPORTED_MODULE_2___default())($prices, {});\n    new (hequalizer__WEBPACK_IMPORTED_MODULE_2___default())($notes, {});\n    new (hequalizer__WEBPACK_IMPORTED_MODULE_2___default())($levels, {});\n    this.hequalizerImages.push(hequalizerImages);\n  }\n  configTabs() {\n    const $tabsComponent = this.$section.querySelector(\"tabs-component\");\n\n    // Ningun Carrusel esta activo hasta que se selecciona\n    // Solo Iniciamos el carrusel del tab principal activo\n    this.configSwipper($tabsComponent.data.content);\n\n    // Proviene de un web component\n    // Listener para cada que se cambia de tab\n    // regresa la data con el tab y content activo\n    $tabsComponent.subscribe(data => {\n      this.configSwipper(data.content);\n    });\n  }\n}\nconst sectionConfig = {\n  onLoad() {\n    this.featuredCollectionsTabs = new FeaturedCollectionsTabs(this.container);\n  }\n};\nif (_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.registered[sectionId] == null) {\n  (0,_shopify_theme_sections__WEBPACK_IMPORTED_MODULE_1__.register)(sectionId, sectionConfig);\n}\n\n//# sourceURL=webpack://getmore-workflow/./zrc/scripts/sections/homepage/featured-collections-tabs.js?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/******/ 	// the startup function
/******/ 	// It's empty as some runtime module handles the default behavior
/******/ 	__webpack_require__.x = x => {};
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	(() => {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// Promise = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			"featured-collections-tabs": 0
/******/ 		};
/******/ 		
/******/ 		var deferredModules = [
/******/ 			["./zrc/scripts/sections/homepage/featured-collections-tabs.js","commons"]
/******/ 		];
/******/ 		// no chunk on demand loading
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		var checkDeferredModules = x => {};
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = (parentChunkLoadingFunction, data) => {
/******/ 			var [chunkIds, moreModules, runtime, executeModules] = data;
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0, resolves = [];
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					resolves.push(installedChunks[chunkId][0]);
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 			for(moduleId in moreModules) {
/******/ 				if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 					__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 			}
/******/ 			if(runtime) runtime(__webpack_require__);
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			while(resolves.length) {
/******/ 				resolves.shift()();
/******/ 			}
/******/ 		
/******/ 			// add entry modules from loaded chunk to deferred list
/******/ 			if(executeModules) deferredModules.push.apply(deferredModules, executeModules);
/******/ 		
/******/ 			// run deferred modules when all chunks ready
/******/ 			return checkDeferredModules();
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = globalThis["webpackChunkgetmore_workflow"] = globalThis["webpackChunkgetmore_workflow"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 		
/******/ 		function checkDeferredModulesImpl() {
/******/ 			var result;
/******/ 			for(var i = 0; i < deferredModules.length; i++) {
/******/ 				var deferredModule = deferredModules[i];
/******/ 				var fulfilled = true;
/******/ 				for(var j = 1; j < deferredModule.length; j++) {
/******/ 					var depId = deferredModule[j];
/******/ 					if(installedChunks[depId] !== 0) fulfilled = false;
/******/ 				}
/******/ 				if(fulfilled) {
/******/ 					deferredModules.splice(i--, 1);
/******/ 					result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
/******/ 				}
/******/ 			}
/******/ 			if(deferredModules.length === 0) {
/******/ 				__webpack_require__.x();
/******/ 				__webpack_require__.x = x => {};
/******/ 			}
/******/ 			return result;
/******/ 		}
/******/ 		var startup = __webpack_require__.x;
/******/ 		__webpack_require__.x = () => {
/******/ 			// reset startup function so it can be called again when more startup code is added
/******/ 			__webpack_require__.x = startup || (x => {});
/******/ 			return (checkDeferredModules = checkDeferredModulesImpl)();
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// run startup
/******/ 	__webpack_require__.x();
/******/ })()
;